
/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */





// Return early if the navigation don't exist.
/*if ( ! siteNavigation ) {
	return;
}*/

//const menuContainer = siteNavigation.getElementsByClassName( 'wp-block-navigation__responsive-container' )[ 0 ];
/*const button = siteNavigation.getElementsByTagName( 'button' )[ 0 ];

// Return early if the button don't exist.
if ( 'undefined' === typeof button ) {
	return;
}

const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

// Hide menu toggle button if menu is empty and return early.
if ( 'undefined' === typeof menu ) {
	button.style.display = 'none';
	return;
}

if ( ! menu.classList.contains( 'nav-menu' ) ) {
	menu.classList.add( 'nav-menu' );
}*/


/**
	 * Switching Header fixed states when scrolling.
	 */

 const header = document.querySelector( 'header.site-header' );

 if (header) {

	/*const site_logo = header.getElementsByClassName("site-logo");
	if (site_logo) {
		site_logo = site_logo[0];
		site_logo.addEventListener('transitionstart', () => {
			if (!siteNavigation.classList.contains( 'toggled' )) {
				menuContainer.classList.remove( 'animate' );
			}
		});
	}*/

	document.addEventListener('scroll', (e) => {
		if (!header.classList.contains("sticky") && window.scrollY > 0) {
			header.classList.add("sticky");
		} else if (window.scrollY == 0) {
			header.classList.remove("sticky");
		}

	});

}
